import { ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { CatModel } from "src/core/categories/categories.models";
import { CategoriesSandbox } from "src/core/categories/categories.sandbox";
import { CommonSandbox } from "src/core/common/common.sandbox";
import { CategoryModel } from "src/core/common/models/category.model";
import { MessageService } from "src/core/services/messages.service";
import { environment } from "src/environments/environment";
import { PromtDialogComponent } from "../promt-dialog/promt.dialog";

@Component({
    templateUrl: './categories-selection.dialog.html',
    styleUrls: ['./categories-selection.dialog.scss']
})
export class CategoriesSelectionDialogComponent implements OnInit, OnDestroy {
    @ViewChild('fileInput') fileInput: ElementRef;
    private subs: Subscription[] = [];
    value = '';
    availableCats: CatModel[] = [];
    filteredCats: CatModel[] = [];

    private categories: CategoryModel[];
    currentCategory: CategoryModel;

    mainCategoryName = '';
    file: File;

    editMode = false;

    public IMAGES_URL = environment.IMAGES_URL;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { catId: number | string, editedCat: CatModel },
        private message: MessageService,
        private cd: ChangeDetectorRef,
        private dialogRef: MatDialogRef<CategoriesSelectionDialogComponent>,
        private dialog: MatDialog,
        private categoriesSandbox: CategoriesSandbox,
        private commonSandbox: CommonSandbox
    ) {
        this.categoriesSandbox.doClearUpdateGetCategoriesItemState();
    }

    ngOnInit(): void {
        this.getCategories();

        this.subs.push(this.commonSandbox.getCategoryListData$.subscribe((categories: CategoryModel[]) => {
            if (categories && this.data && this.data.catId) {
                this.currentCategory = categories.find(el => +el.id === +this.data.catId);
                if (this.currentCategory) {
                    this.mainCategoryName = this.currentCategory.value;
                    console.log(this.mainCategoryName);
                }
            }
        }));

        this.subs.push(this.categoriesSandbox.getCategoriesListData$.subscribe(res => {
            if (res) {
                this.availableCats = res;
                this.filterCat();
            }
        }));
        this.subs.push(this.categoriesSandbox.getCategoriesListFailData$.subscribe(res => {
            if (res) {
                this.message.log('Server error!')
            }
        }));
        this.subs.push(this.categoriesSandbox.createCategoriesData$.subscribe(res => {
            if (res) {
                // this.value = '';
                this.getCategories();
            }
        }));
        this.subs.push(this.categoriesSandbox.createCategoriesFailData$.subscribe(res => {
            if (res) {
                this.value = '';
                this.message.log('Server error!')
            }
        }));
        this.subs.push(this.categoriesSandbox.deleteCategoriesItemData$.subscribe(res => {
            if (res) {
                this.value = '';
                this.message.log('Category removed!');
                this.getCategories();
            }
        }));
        this.subs.push(this.categoriesSandbox.deleteCategoriesItemFailData$.subscribe(res => {
            if (res) {
                this.value = '';
                this.message.log('Server error!');
            }
        }));

        this.subs.push(this.categoriesSandbox.updateCategoriesItemData$.subscribe(res => {
            if (res) {
                console.log(res);
                this.dialogRef.close({ value: this.value });
            }
        }))

        if (this.data.editedCat && this.data.editedCat.id) {
            console.log(this.data.editedCat)
            this.editMode = true;
            this.value = this.data.editedCat.value;
        }
    }

    clear(): void {
        this.value = '';
        this.filterCat();
    }

    private getCategories(): void {
        const params: any = {};
        if (this.data && this.data.catId) {
            params.maincategory = this.data.catId
        }
        this.categoriesSandbox.doGetCategoriesList(params);
    }

    addCategory(): void {
        if (!this.value) {
            return;
        }
        const params: FormData = new FormData();
        params.append('value', this.value);
        params.append('description', '');
        // const params: any = {
        //     value: this.value,
        //     description: ''
        // }
        if (this.data && this.data.catId) {
            // params.maincategory = this.data.catId
            params.append('maincategory', '' + this.data.catId);
        }
        if (this.file) {
            params.append('image', this.file, this.file.name);
        }
        this.categoriesSandbox.doCreateCategory(params);
    }

    update(): void {
        if (!this.value) {
            return;
        }
        const params: FormData = new FormData();
        params.append('value', this.value);
        params.append('description', '');
        if (this.data && this.data.catId) {
            params.append('maincategory', '' + this.data.catId);
        }
        if (this.file) {
            params.append('image', this.file, this.file.name);
        }
        this.categoriesSandbox.doUpdateCategoriesItem(this.data.editedCat.id, params);
    }

    filterCat(e = ''): void {
        if (this.editMode) {
            this.filteredCats = [];
            return;
        }
        if (this.value) {
            this.filteredCats = this.availableCats.filter(el => el.value.toLocaleLowerCase().indexOf(this.value.toLocaleLowerCase()) >= 0);
        } else {
            this.filteredCats = this.availableCats;
        }
        this.cd.markForCheck();
    }

    selectCat(cat: CatModel): void {
        this.dialogRef.close(cat);
    }

    removeCat(cat: CatModel): void {
        this.dialog.open(PromtDialogComponent).afterClosed().subscribe(res => {
            if (res) {
                this.categoriesSandbox.doRemoveCategoriesItem(cat.id);
            }
        })
    }

    onFileChanged(event: any): void {
        const URL = window.URL || window.webkitURL;
        const Img = new Image();

        const fileToUpload = event.target.files[0] as File;
        this.file = fileToUpload;
        Img.src = URL.createObjectURL(fileToUpload);

        Img.onload = (e: any) => {
            // const ratio = 340 / 192;

            const height = e.path[0].height;
            const width = e.path[0].width;

            if (height === width) {
                // success
            } else {
                this.file = null;
                this.fileInput.nativeElement.value = '';
                this.message.log('Image ratio must be 1:1');
            }
        }
    }

    ngOnDestroy(): void {
        this.subs.map(s => s.unsubscribe());
    }
}